export default "__VITE_ASSET__B_f8rNvC__"